<template>
    <div class="block raw-development-block adjustment-block" rel="block_raw-development" @click="blockSelected">
        <div class="header-container">
            <label class="lookup_block_name name">Raw Development</label>

            <div class="controls-wrapper">
                <i id="reset-raw-development-btn" class="btn-reset-block material-icons" @click="resetValues"
                   data-tippy-content="Reset"
                >settings_backup_restore</i>
                <i class="toggle_arrow expand_options material-icons mr-0" data-tippy-content="Expand"
                   v-show="!expanded" @click="expanded = !expanded"
                >expand_more</i>
                <i class="toggle_arrow collapse_options material-icons mr-0" style="display: none;"
                   v-show="expanded" @click="expanded = !expanded"
                   data-tippy-content="Collapse"
                >expand_less</i>
            </div>
        </div>

        <v-expand-transition>
            <div class="body-container" v-show="expanded">
                <div class="block-option">
                    <span>Colour Space</span>
                    <v-menu offset-y :content-class="'raw-option-menu-container'"
                            :disabled="false"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <div class="dropdown-activator" v-bind="attrs" v-on="on"
                                 :class="{disabled: false}"
                            >
                                <span>{{ values.colourSpace.name }}</span>
                                <i class="material-icons">arrow_drop_down</i>
                            </div>
                        </template>

                        <v-list>
                            <v-list-item v-for="availableColourSpace in availableColourSpaces"
                                         :key="availableColourSpace.value"
                                         @click="values.colourSpace = availableColourSpace"
                            >
                                {{ availableColourSpace.name }}
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>

                <!--                <div class="block-option">-->
                <!--                    <span>Filmic Curve</span>-->
                <!--                    <v-menu offset-y :content-class="'raw-option-menu-container'"-->
                <!--                            :disabled="values.colourSpace.value == 6"-->
                <!--                    >-->
                <!--                        <template v-slot:activator="{ on, attrs }">-->
                <!--                            <div class="dropdown-activator" v-bind="attrs" v-on="on"-->
                <!--                                 :class="{disabled: values.colourSpace.value == 6}"-->
                <!--                            >-->
                <!--                                <span>{{ values.filmicCurve.name }}</span>-->
                <!--                                <i class="material-icons">arrow_drop_down</i>-->
                <!--                            </div>-->
                <!--                        </template>-->

                <!--                        <v-list>-->
                <!--                            <v-list-item v-for="availableFilmicCurve in availableFilmicCurves"-->
                <!--                                         :key="availableFilmicCurve.name"-->
                <!--                                         @click="updateFilmicCurve(availableFilmicCurve)"-->
                <!--                                         :class="{hide: values.colourSpace.value !== 6 && availableFilmicCurve.name == 'Linear'}"-->
                <!--                            >-->
                <!--                                {{ availableFilmicCurve.name }}-->
                <!--                            </v-list-item>-->
                <!--                        </v-list>-->
                <!--                    </v-menu>-->
                <!--                </div>-->

                <!--                <div class="block-option">-->
                <!--                    <span>Rotate Image</span>-->
                <!--                    <v-menu offset-y :content-class="'raw-option-menu-container'"-->
                <!--                            :disabled="false"-->
                <!--                    >-->
                <!--                        <template v-slot:activator="{ on, attrs }">-->
                <!--                            <div class="dropdown-activator" v-bind="attrs" v-on="on"-->
                <!--                                 :class="{disabled: false}"-->
                <!--                            >-->
                <!--                                <span>{{ values.rotateImage.name }}</span>-->
                <!--                                <i class="material-icons">arrow_drop_down</i>-->
                <!--                            </div>-->
                <!--                        </template>-->

                <!--                        <v-list>-->
                <!--                            <v-list-item v-for="availableRoateImage in availableRoateImages"-->
                <!--                                         :key="availableRoateImage.value"-->
                <!--                                         @click="updateRotateImage(availableRoateImage)"-->
                <!--                            >-->
                <!--                                {{ availableRoateImage.name }}-->
                <!--                            </v-list-item>-->
                <!--                        </v-list>-->
                <!--                    </v-menu>-->
                <!--                </div>-->

                <!--                <div class="block-option">-->
                <!--                    <span>Use Camera White Balance</span>-->
                <!--                    <div class="switch switch-container" :class="{disabled: values.colourSpace.name == 'ACES2065-1'}">-->
                <!--                        <input type="checkbox" v-model="values.useCameraWhiteBalance"-->
                <!--                               :disabled="values.colourSpace.name == 'ACES2065-1'"-->
                <!--                               :class="{disabled: values.colourSpace.name == 'ACES2065-1'}"-->
                <!--                        />-->
                <!--                        <span class="slider round"></span>-->
                <!--                    </div>-->
                <!--                </div>-->

                <!--                <div class="block-option mb-0">-->
                <!--                    <span>Auto Average White Balance</span>-->
                <!--                    <div class="switch switch-container" :class="{disabled: values.colourSpace.name == 'ACES2065-1'}">-->
                <!--                        <input type="checkbox" v-model="values.autoAverageWhiteBalance"-->
                <!--                               :disabled="values.colourSpace.name == 'ACES2065-1'" :class="{disabled: values.colourSpace.name == 'ACES2065-1'}"-->
                <!--                        />-->
                <!--                        <span class="slider round"></span>-->
                <!--                    </div>-->
                <!--                </div>-->

                <!--            <div class="block-option">-->
                <!--                <span>Chromatic Abberation Correction</span>-->
                <!--                <div class="switch switch-container" :class="{disabled: values.extractEmbeddedThumbnail}">-->
                <!--                    <input type="checkbox" v-model="values.chromaticAbberationCorrection" :disabled="values.extractEmbeddedThumbnail" :class="{disabled: values.extractEmbeddedThumbnail}" />-->
                <!--                    <span class="slider round"></span>-->
                <!--                </div>-->
                <!--            </div>-->

                <!--                reminding you that for aces2065-1 we auto use "-g 2.2 2.5".
                it's called "Exposure Compensation" and it's on by default. user can turn it
                off. it's available only for aces2065. if you debayer into srgb for example that
                option is greyed out-->

                <!--                <div class="block-option">-->
                <!--                    <span>Tone Mapping</span>-->
                <!--                    <div class="switch switch-container" :class="{disabled: values.colourSpace.value !== 6}">-->
                <!--                        <input type="checkbox" v-model="values.toneMapping"-->
                <!--                               :disabled="values.colourSpace.value !== 6"-->
                <!--                               :class="{disabled: values.colourSpace.value !== 6}"-->
                <!--                        />-->
                <!--                        <span class="slider round"></span>-->
                <!--                    </div>-->
                <!--                </div>-->

                <div class="block-option">
                    <span>Highlight Recovery</span>
                    <div class="switch switch-container">
                        <input type="checkbox" v-model="values.highlightRecovery" />
                        <span class="slider round"></span>
                    </div>
                </div>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>

export default {
    data() {
        return {
            isResetingValues: false,
            availableColourSpaces: [
                { name: 'ACES2065-1', value: 6 },
                { name: 'sRGB', value: 1, filmicCurve: '2.4 12.9' },
                { name: 'Adobe RGB', value: 2, filmicCurve: '2.2 0' },
                { name: 'ProPhoto RGB', value: 4, filmicCurve: '1.8 0' },
            ],

            // availableFilmicCurves: [
            //     { name: 'Linear', value: "" },
            //     { name: 'None', value: "" },
            //     { name: 'Low Contrast', value: "2.2 8.0" },
            //     { name: 'Standard', value: "2.2 4.5" },
            //     { name: 'High Contrast', value: "2.2 2.5" },
            // ],

            // availableRoateImages: [
            //     { name: 'None', value: 0 },
            //     { name: '180', value: 3 },
            //     { name: '90CCW', value: 5 },
            //     { name: '90CW', value: 6 },
            // ],
            values: {
                // useCameraWhiteBalance: true,
                // autoAverageWhiteBalance: false,
                // chromaticAbberationCorrection: true,
                colourSpace: { name: '', value: '', },
                highlightRecovery: false,
                // toneMapping: true,
                // filmicCurve: { name: '', value: '', },
                // rotateImage: { name: '', value: '', },
            },

            updating: false,
            expanded: true,
        }
    },

    created() {
        this.resetValues();
    },

    mounted() {
        this.$root.rawDevelopment = this;
    },

    watch: {
        values: {
            deep: true,
            async handler() {
                // if (window.gpu) {
                //     gpu.disableAllCreativePasses(false);
                // }

                // await this.develop();
            }
        },
        'values.colourSpace': function (newVal, oldVal) {
            if (!this.$store.state.Projects.image) return;
            if (this.isResetingValues) return;

            // if (newVal.value == 6) this.values.filmicCurve = this.availableFilmicCurves[0];
            // if (newVal.value !== 6 && this.values.filmicCurve.name == 'Linear') {
            //     this.values.filmicCurve = this.availableFilmicCurves[1];
            // }

            let IDTname = newVal.name;
            if (IDTname == 'sRGB') IDTname = 'sRGB - Raw';

            // UI.IDT.selectByName(IDTname)
        }
    },

    methods: {
        // updateColourSpace(colourSpace) {
        //     this.values.colourSpace = colourSpace;
        // },

        // updateFilmicCurve(filmicCurve) {
        //     this.values.filmicCurve = filmicCurve;
        // },

        // updateRotateImage(rotateImage) {
        //     this.values.rotateImage = rotateImage;
        // },

        prepareOptions(exportingImage = false) {
            let options = "";

            options += `-o ${this.values.colourSpace.value}`;

            if (!exportingImage) {
                options += ' -h';
            } else {
                options += ' -q 0';
            }

            if (this.values.colourSpace.value !== 6) {
                options += ` -g ${this.values.colourSpace.filmicCurve}`;
            }

            // if (this.values.toneMapping && this.values.colourSpace.value == 6) {
            //     options += ' -g 2.2 2.5';
            // }

            // if (loader.activeMedia.exif?.orientation && this.values.rotateImage.value !== 0) {
            //     options += ` -t ${this.values.rotateImage.value}`;
            // } else {
            //     options += ` -t ${loader.activeMedia.exif.orientation}`;
            // }

            // if (this.values.chromaticAbberationCorrection) {
            //     options += ' -acae 0 0';
            // }

            // if (this.values.useCameraWhiteBalance) {
            //     options += ' -w';
            // }

            // if (this.values.autoAverageWhiteBalance) {
            //     options += ' -a';
            // }

            if (this.values.highlightRecovery) {
                options += ' -H 2';
            }

            // Camera White Balance
            options += ' -w';

            return options;
        },

        async applyData(data) {
            this.values = {...data};
            // this.values.filmicCurve = {...data.filmicCurve};

            await new Promise(resolve => {
                let interval = setInterval(() => {
                    if (!this.updating) {
                        clearInterval(interval);
                        resolve();
                    }
                }, 50);
            })
        },

        blockSelected(e) {
            blocks.primaryBlockHandler($(e.currentTarget));
        },

        async selectDefaultIDT() {
            await UI.IDT.selectByName('ProPhoto RGB')
        },

        async resetValues() {
            // this.values.useCameraWhiteBalance = true;
            // this.values.autoAverageWhiteBalance = false;
            // this.values.chromaticAbberationCorrection = true;
            this.isResetingValues = true;
            this.values.colourSpace = this.availableColourSpaces[3];
            this.values.highlightRecovery = false;
            // this.values.toneMapping = true;
            // this.values.filmicCurve = this.availableFilmicCurves[0];
            // this.values.rotateImage = this.availableRoateImages[0];

            this.isResetingValues = false;
        },

        imageDataToBlob(imageData) {
            let w = imageData.width;
            let h = imageData.height;
            let canvas = document.getElementById("develop-raw-canvas");
            canvas.width = w;
            canvas.height = h;
            let ctx = canvas.getContext("2d");
            ctx.putImageData(imageData, 0, 0);        // synchronous

            return new Promise((resolve) => {
                canvas.toBlob(resolve); // implied image/png format
            });
        },

        async develop() {
            if (!this.$store.state.Projects.image) return;
            if (this.updating && !this.$store.state.UI.compareView.some(item => item.loaded)) return;

            this.updating = true;
            // gpu.disableAllCreativePasses(false);
            gpu.composer.passes[1].enabled = false;
            gpu.getLastPass().enabled = false;
            let imageId = this.$store.state.Projects.image;

            await new Promise(resolve => {
                this.$nextTick(async () => {
                    window.UI.showImageLoader(true);

                    // let options = this.prepareOptions();
                    let options = "-T";

                    if (loader.activeMedia.rawDevelopment.values == options) {
                        window.UI.hideImageLoader();
                        gpu.composer.passes[1].enabled = true;
                        gpu.getLastPass().enabled = true;
                        gpu.render();
                        this.updating = false;
                        resolve();
                    }

                    window.loader.resetActiveMediaRawDeveloped();

                    let imageStore = await imagesStore.getItem(this.$store.state.Projects.image);
                    if (!imageStore) imageStore = await imagesStore.getItem(this.$store.state.Projects.image);

                    if (imageStore?.rawDevelopment?.values == options) {
                        loader.activeMedia.rawDevelopment = imageStore.rawDevelopment;
                    } else {
                        let result = await this.extractImageFromRaw(loader.activeMedia.file, options);
                        let fileType = result.extension.split('.')[1];

                        // jpeg
                        if (result.preview) {
                            fileType = 'jpg';
                            let maxTextureSize = gpu.exportRenderer.capabilities.maxTextureSize;
                            if (result.preview.width > maxTextureSize || result.preview.height > maxTextureSize) {
                                loader.activeMedia.rawDevelopment.blob = await this.imageDataToBlob(result.preview);
                            } else {
                                loader.activeMedia.rawDevelopment.imageData = result.preview;
                            }
                        }

                        // exr
                        else {
                            let blob = new File([result.file_output], `image.${fileType}`);
                            result = await loader.convertImage(blob, fileType);
                            loader.activeMedia.rawDevelopment.blob = result.blob;
                        }

                        loader.activeMedia.rawDevelopment.type = fileType;
                        loader.activeMedia.rawDevelopment.values = options;

                        let rawDevelopment = { ...loader.activeMedia.rawDevelopment };

                        if (loader.activeMedia.rawDevelopment.imageData) {
                            let imageBlob = await this.imageDataToBlob(rawDevelopment.imageData);
                            rawDevelopment.blob = imageBlob;
                            rawDevelopment.imageData = null;
                        }

                        let storeData = await imagesStore.getItem(imageId);
                        if (storeData) {
                            await imagesStore.setItem(imageId, {
                                ...storeData,
                                rawDevelopment
                            });
                        } else {
                            storeData = await imagesStore.getItem(imageId);
                            if (storeData) {
                                await imagesStore.setItem(imageId, {
                                    ...storeData,
                                    rawDevelopment
                                });
                            }
                        }
                    }

                    if (loader.activeMedia.rawDevelopment.blob) {
                        loader.activeMedia.rawDevelopment.url = URL.createObjectURL(loader.activeMedia.rawDevelopment.blob);
                    }

                    if (imageId == this.$store.state.Projects.image) {
                        await gpu.initNewImage();
                    }

                    window.UI.hideImageLoader();
                    this.updating = false;

                    gpu.composer.passes[1].enabled = true;
                    gpu.getLastPass().enabled = true;
                    gpu.render();
                    resolve();
                });
            })
        },

        async extractThumbnailFromRaw(file, returnBlob = true, customOption = false) {
            let option = "-T";
            if (customOption) option = customOption;

            let result = await this.extractImageFromRaw(file, option);

            if (!returnBlob) return result;

            if (result.file_output) {
                return new Blob([result.file_output], { type: "image/jpeg" });
            }

            return await loader.fetchDefaultThumbnail();
        },

        extractImageFromRaw(file, options) {
            return new Promise(resolve => {
                let worker = new Worker("assets/vendor/libraw/weblibraw_worker.js");

                worker.onmessage = async e => {
                    let result = e.data[0]
                    worker.terminate();
                    resolve(result);
                }

                const reader = new FileReader()
                reader.onload = () => {
                    let data = new Uint8Array(reader.result);
                    worker.postMessage([data, options]);
                };

                reader.readAsArrayBuffer(file);
            })
        }

    }

};


</script>

<style lang="scss" scoped>
.raw-development-block {
    margin-bottom: 5px;
}

.body-container {
    padding: 6px 12px 0;
}

.block-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;

    span {
        font-size: 0.9rem;
    }

    .dropdown-activator {
        display: flex;
        align-items: center;
        font-size: 0.9rem;

        i {
            font-size: 18px
        }
    }
}
</style>

<style lang="scss">
.raw-option-menu-container {
    border-radius: var(--box-rounding);

    .v-list {
        background: var(--dark-gray);
        padding: 25px 0;

        .v-list-item.v-list-item--link {
            min-height: 20px;
            padding: 0 25px;
            color: var(--font-default-color) !important;
            font-size: 1rem;
            cursor: pointer;

            &:hover {
                background: #363636;
            }
        }
    }
}
</style>
